import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-credit-card",
  templateUrl: "./med-icon-credit-card.component.html",
})
export class MedIconCreditCardComponent extends SvgMixinComponent {}
